/* istanbul ignore file */

import React from 'react';

/** Lazy ClientComputedFileList (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedFileList = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-file-list' */
            './ClientComputedFileList'
        ),
);
